import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

class IndexPageAnimationsClass {
  init() {
    this.tooltipAnimation();

    // небольшой трюк для ScrollTrigger
    setTimeout(() => {
      const currentScroll = window.scrollY;
      window.scrollTo({ top: currentScroll + 1, behavior: "instant" });
    }, 100);

    gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

    const wrappers = document.querySelectorAll(".promo__bulletin-inner");
    const leaves = document.querySelectorAll(".promo__bulletin");
    const laptop = document.querySelector(".promo__monitor");
    const header = document.querySelector(".header");

    if (window.location.pathname === "/") {
      header.style.opacity = 0;
      header.style.transform = "translateY(30px)";
    }

    // --- Timeline загрузки ---
    gsap
      .timeline()
      .to(".header", { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" })
      .to(
        ".promo",
        { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" },
        "-=0.5"
      )
      .to(
        ".promo__image-wrapper",
        { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" },
        "-=0.5"
      )
      .to(
        ".promo__bulletin_1",
        { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" },
        "-=0.5"
      )
      .to(
        ".promo__bulletin_2",
        { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" },
        "-=0.65"
      )
      .to(
        ".promo__bulletin_3",
        { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" },
        "-=0.65"
      )
      .to(
        ".promo__bulletin_4",
        { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" },
        "-=0.65"
      )
      .to(
        ".promo__footer",
        { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" },
        "-=0.5"
      );

    if (window.innerWidth >= 760) {
      // --- Параллакс мыши ---
      const parallaxDepth = [30, 50, 70, 90];
      const parallaxState = { strength: 1 };

      document.addEventListener("mousemove", (e) => {
        if (parallaxState.strength <= 0) return;

        const { innerWidth, innerHeight } = window;
        const x = (e.clientX - innerWidth / 2) / innerWidth;
        const y = (e.clientY - innerHeight / 2) / innerHeight;

        wrappers.forEach((wrapper, i) => {
          gsap.to(wrapper, {
            x: x * parallaxDepth[i] * parallaxState.strength,
            y: y * parallaxDepth[i] * parallaxState.strength,
            duration: 0.4,
            ease: "power2.out",
            overwrite: true,
          });
        });
      });

      // --- MotionPath эффект “слёта бюллетеней” ---
      const initialPositions = new Map();

      leaves.forEach((leaf) => {
        const rect = leaf.getBoundingClientRect();
        initialPositions.set(leaf, { rect });
      });

      const initLeavesAnimation = (reverse = false) => {
        if (!laptop) return;

        const laptopRect = laptop.getBoundingClientRect();
        const laptopCenter = {
          x: laptopRect.left + laptopRect.width / 2 + window.scrollX,
          y: laptopRect.top + laptopRect.height / 2 + window.scrollY,
        };

        leaves.forEach((leaf, index) => {
          // 💥 Останавливаем все активные анимации перед запуском новой
          gsap.killTweensOf(leaf);

          const startRect = initialPositions.get(leaf).rect;
          const start = {
            x: startRect.left + startRect.width / 2 + window.scrollX,
            y: startRect.top + startRect.height / 2 + window.scrollY,
          };

          if (!reverse) {
            // Единая плавная дуга (немного смещённая по X для естественности)
            const offsetX = (index - leaves.length / 2) * 40;
            const cp = {
              x: start.x + offsetX,
              y: start.y - 120,
            };

            gsap.to(leaf, {
              motionPath: {
                path: [
                  { x: 0, y: 0 },
                  { x: cp.x - start.x, y: cp.y - start.y },
                  { x: laptopCenter.x - start.x, y: laptopCenter.y - start.y },
                ],
                curviness: 1.4,
              },
              rotation: 0,
              scale: 0.3,
              opacity: 0,
              filter: "blur(3px)",
              duration: 1.5,
              ease: "power2.inOut",
              overwrite: "auto", // предотвращает конфликты
            });
          } else {
            // Возврат обратно
            gsap.to(leaf, {
              x: 0,
              y: 0,
              rotation: 0,
              scale: 1,
              opacity: 1,
              filter: "blur(0px)",
              duration: 1,
              ease: "power2.out",
              overwrite: "auto",
            });
          }
        });
      };

      // --- Управление запуском ---
      let animationPlayed = false;
      const onScroll = () => {
        if (window.scrollY > 10 && !animationPlayed) {
          animationPlayed = true;
          initLeavesAnimation(false);
        } else if (window.scrollY <= 10 && animationPlayed) {
          animationPlayed = false;
          initLeavesAnimation(true);
        }
      };
      window.addEventListener("scroll", onScroll);

      // --- Контроль возврата параллакса ---
      const checkScroll = () => {
        if (window.scrollY <= 1) {
          wrappers.forEach((wrapper) => {
            gsap.to(wrapper, {
              x: 0,
              y: 0,
              duration: 0.5,
              ease: "power2.out",
              overwrite: "auto",
            });
          });
          parallaxState.strength = 1;
        }
      };
      window.addEventListener("scroll", checkScroll);
      checkScroll();
    }
  }

  // --- Tooltip текстовая анимация ---
  tooltipAnimation() {
    const texts = [
      "Собрание проведено",
      "Выгрузили на ГИС ЖКХ",
      "Опубликовали протокол",
      "Распознали бюллетени",
      "Подготовили документы",
    ];

    const textEl = document.getElementById("promo-tooltip-text");
    if (!textEl) return;

    let index = 0;

    function changeText() {
      gsap.to(textEl, {
        duration: 0.3,
        opacity: 0,
        onComplete: () => {
          index = (index + 1) % texts.length;
          textEl.textContent = texts[index];
          gsap.to(textEl, { duration: 0.3, opacity: 1 });
        },
      });
    }

    setInterval(changeText, 2000);
  }
}

export const IndexPageAnimations = new IndexPageAnimationsClass();
